import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { routeHighlightMap }  from '@/utils/enums.js'

// 路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

let XC_IP = process.env.VUE_APP_XC_IFRAME_URL
if (XC_IP) {
  const _url = new URL(XC_IP)
  XC_IP = _url.origin
}
XC_IP = XC_IP || 'http://localhost:9999'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/projectDetails'
    },
    {
      path: '/',
      component: resolve => require(['../components/common/home.vue'], resolve),
      meta: { title: '自述文件' },
      children: [
        {
          path: '/projectDetails',
          component: resolve => require(['../page/project/project.vue'], resolve),
          name: 'projectDetails',
          meta: { title: '首页' }
        }, {
          path: '/management/:index?',
          component: resolve => require(['../page/users/distribute.vue'], resolve),
          name: 'management',
          meta: { title: '权限管理' }

        }, {
          path: '/install/:data?/:areadisplay?',
          component: resolve => require(['../page/install/install.vue'], resolve),
          name: 'install',
          meta: { title: '设备安装' }
        }, {
          path: '/monitoring',
          component: resolve => require(['../page/monitor/monitor.vue'], resolve),
          name: 'monitoring',
          meta: { title: '监控' }
        },
        {
          path: '/demo',
          component: resolve => require(['../page/demo/index.vue'], resolve),
          name: 'oppleDemo',
          meta: { title: 'demo' }
        },
        {
          path: '/tianmu-design',
          component: resolve => require(['../page/tianmu-design/index.vue'], resolve),
          name: 'tianmuDesign',
          meta: { title: '天幕设计' },
        },
        {
          path: '/networkCheck',
          component: resolve => require(['../page/networkCheck/index.vue'], resolve),
          name: 'networkCheck',
          meta: { title: '网络检测' }
        },
        // {
        //   path: '/ai-paint',
        //   component: resolve => require(['../page/ai-paint/index.vue'], resolve),
        //   name: 'aiPaint',
        //   meta: { title: 'ai绘图' }
        // }, 
        // {
        //   path: '/opple-demo',
        //   component: resolve => require(['../page/demo/index.vue'], resolve),
        //   name: 'oppleDemo',
        //   meta: { title: 'demo' }
        // },
         {
          path: '/control/:data?',
          component: resolve => require(['../page/control-ts/control.vue'], resolve),
          name: 'control',
          meta: { title: '照明控制' }
        }, {
          path: '/sceneHandle',
          component: resolve => require(['../page/control-ts/scene/sceneHandle/index.vue'], resolve),
          name: 'sceneHandle',
          meta: { title: '场景信息' }
        }, 
        {
          path: '/lightStripScene',
          component: resolve => require(['../page/control-ts/scene/LightStripScene/index.vue'], resolve),
          name: 'lightStripScene',
          meta: { title: '场景信息' }
        },
        {
          path: '/lightStripSceneCanvas',
          component: resolve => require(['../page/control-ts/scene/LightStripScene/LightStripSceneCanvas.vue'], resolve),
          name: 'lightStripSceneCanvas',
          meta: { title: '场景信息' }
        }, 
        {
          path: '/automation',
          component: resolve => require(['../page/ifttt/ifttt.vue'], resolve),
          name: 'automation',
          meta: { title: '自动化' }
        }, {
          path: '/iftttCustomSet',
          component: resolve => require(['../page/ifttt/iftttCustomSet.vue'], resolve),
          name: 'iftttCustomSet',
          meta: { title: '自定义' }
        },{
          path: '/iftttCustomSetTime',
          component: resolve => require(['../page/ifttt/iftttCustomSetTime.vue'], resolve),
          name: 'iftttCustomSetTime',
          meta: { title: '自定义' }
        }, {
          path: '/iftttTemplateSet/:id',
          component: resolve => require(['../page/ifttt/iftttTemplateSet.vue'], resolve),
          name: 'iftttTemplateSet',
          meta: {
            title: '自定义'
          }
        }, {
          path: '/iftttCustomSetPanel',
          component: resolve => require(['../page/ifttt/iftttCustomSetPanel.vue'], resolve),
          name: 'iftttCustomSetPanel',
          meta: { title: '面板自动化' }
        }, 
        // {
        //   path: '/templates',
        //   component: resolve => require(['../page/ifttt/iftttTemplate1Set.vue'], resolve),
        //   name: 'templates',
        //   meta: { title: '模板' }
        // }
        {
          path: '/iftttNotice',
          component: resolve => require(['../page/ifttt/iftttNotice/index.vue'], resolve),
          name: 'iftttNotice',
          meta: { title: '通知' }
        },{
          path: '/systemLog',
          component: resolve => require(['../page/logers/logs.vue'], resolve),
          name: 'systemLog',
          meta: { title: '系统日志' }
        },
        {
          path: '/failureList',
          component: resolve => require(['../page/failure-list/failure-list.vue'], resolve),
          name: 'failureList',
          meta: { title: '设备故障' }
        },
        {
          path: '/projectMsg/:data?/:type?',
          component: resolve => require(['../page/project/projectMsg.vue'], resolve),
          name: 'projectMsg',
          meta: { title: '项目信息' }
        },
        {
          path: '/projectInfor',
          component: resolve => require(['../page/project/projectInfor.vue'], resolve),
          name: 'projectInfor',
          meta: { title: '项目信息' }
        },
        {
          path: '/usersInvite/:ur',
          component: resolve => require(['../page/users/usersInvite.vue'], resolve),
          name: 'usersInvite',
          meta: { title: '用户邀请' }
        },
        {
          path: '/qrcodeInvite/:ur',
          component: resolve => require(['../page/users/qrcodeInvite.vue'], resolve),
          name: 'qrcodeInvite',
          meta: { title: '用户邀请' }
        },
        {
          path: '/addDevice/:data/:pagetype',
          component: resolve => require(['../page/install/device/addDevice.vue'], resolve),
          name: 'addDevice',
          meta: { title: '添加设备' }
        },
        {
          path: '/addVirtualDevice/:data?',
          component: resolve => require(['../page/install/device/deviceVirtual/addVirtualDevice.vue'], resolve),
          name: 'addVirtualDevice',
          meta: { title: '添加虚拟设备' }
        },
        {
          path: '/inviteSuccess',
          component: resolve => require(['../page/users/inviteSuccess.vue'], resolve),
          name: 'inviteSuccess',
          meta: { title: '用户邀请' }
        },
        {
          path: '/findGateway/:data?',
          component: resolve => require(['../page/install/device/deviceVirtual/findGateway.vue'], resolve),
          name: 'findGateway',
          meta: { title: '添加网关' }
        },
        {
          path: '/findEthernet',
          component: resolve => require(['../page/install/device/deviceVirtual/findGateway.vue'], resolve),
          name: 'findEthernet',
          meta: { title: '添加以太网设备' }
        },
        {
          path: '/addTianMu',
          component: resolve => require(['../page/install/device/deviceReal/addTianmuDevice.vue'], resolve),
          name: 'addTianMu',
          meta: { title: '添加天幕' }
        },
        {
          path: '/addCustomTianm',
          component: resolve => require(['../page/install/device/deviceReal/addCustomTianm.vue'], resolve),
          name: 'addCustomTianm',
          meta: { title: '添加天幕' }
        },
        // {
        //   path: '/addEthernetDevice',
        //   component: resolve => require(['../page/install/device/deviceVirtual/EthernetDevice.vue'], resolve),
        //   name: 'addEthernetDevice',
        //   meta: { title: '添加网关' }
        // },
        {
          path: '/findDevice',
          component: resolve => require(['../page/install/device/deviceReal/findDevice.vue'], resolve),
          name: 'findDevice',
          meta: { title: '发现设备' }
        },
        {
          path: '/addThirdDevice/:data?',
          component: resolve => require(['../page/install/device/deviceReal/addThirdDevice.vue'], resolve),
          name: 'addThirdDevice',
          meta: { title: '添加第三方设备' }
        },
        {
          path: '/addVirtualGateway/:data?',
          component: resolve => require(['../page/install/device/deviceVirtual/addVirtualGateway.vue'], resolve),
          name: 'addVirtualGateway',
          meta: { title: '添加虚拟网关' }
        },
        {
          path: '/3dc',
          component: resolve => require(['../page/3dc/3dcontrol.vue'], resolve),
          name: '3dc',
          meta: { title: '维度控制' }
        },
        {
          path: '/ota',
          component: resolve => require(['../page/ota/ota.vue'], resolve),
          name: 'ota',
          meta: { title: '设备ota' }
        },
        {
          path: '/otatask',
          component: resolve => require(['../page/otatask/otataskList.vue'], resolve),
          name: 'otatask',
          meta: { title: 'ota任务' }
        },
        {
          path: '/otataskCreate',
          component: resolve => require(['../page/otatask/otataskCreate.vue'], resolve),
          name: 'otataskCreate',
          meta: { title: 'ota任务创建' }
        },
        {
          path: '/powerStation',
          component: resolve => require(['../page/power-station/index.vue'], resolve),
          name: 'powerStation',
          meta: { title: '光伏电站' }
        },
        {
          path: '/notices',
          component: resolve => require(['../page/notices/index.vue'], resolve),
          name: 'notices',
          meta: { title: '订阅通知' }
        },
        {
          path: '/tianmu',
          component: resolve => require(['../page/control-ts/scene/TianMuScene/index.vue'], resolve),
          name: 'tianmu',
          meta: { title: '天幕场景' }
        },
        {
          path: '/xidingdengScene',
          component: resolve => require(['../page/control-ts/scene/XiDingScene/index.vue'], resolve),
          name: 'xidingdengScene',
          meta: { title: '吸顶灯场景' }
        },
        // {
        //   path: '/lightBox',
        //   component: resolve => require(['../page/lightBox/index.vue'], resolve),
        //   name: 'lightBox',
        //   meta: { title: '光盒子' }
        // }
      ]
    },
    {
      path: '/login',
      component: resolve => require(['../page/login/login.vue'], resolve),
      name: 'login',
      meta: { title: '用户登录' }
    },
    {
      path: '/setPsw',
      component: resolve => require(['../page/login/forgetPassword/forgetPassword.vue'], resolve),
      name: 'setPsw',
      meta: { title: '设置密码' }
    },
    {
      path: '/invateSetPassword/:token',
      component: resolve => require(['../page/login/setpassword/setpassword.vue'], resolve),
      name: 'invateSetPassword',
      meta: { title: '邀请用户设置密码' }
    },
    {
      path: '/regist',
      component: resolve => require(['../page/login/regist/regist.vue'], resolve),
      name: 'regist',
      meta: { title: '注册密码' }
    },
    {
      path: '/invitehandle/:token/:reply/:lang',
      component: resolve => require(['../page/users/invitehandle.vue'], resolve),
      name: 'invitehandle',
      meta: { title: '邀请用户-邮箱接受' }
    },
    // {
    //   path: '/qrcodecontrol',
    //   component: resolve => require(['../page/qrcode/qrcodecontrol.vue'], resolve),
    //   name: 'qrcodecontrol',
    //   meta: { title: '扫码-控制' }
    // },
    {
      path: '/qrcodecontrol',
      redirect: '/qrcodecontrol/areatarget'
    },
    {
      path: '/qrcodecontrol',
      component: resolve => require(['../page/qrcode/components/home.vue'], resolve),
      meta: { title: '自述文件' },
      children: [
        {
          path: '/qrcodecontrol/areatarget',
          component: resolve => require(['../page/qrcode/qrcodeAreaTarget.vue'], resolve),
          name: 'qrcodeareatarget',
          meta: { title: '扫描控制首页' }
        },
        {
          path: '/qrcodecontrol/phonename',
          component: resolve => require(['../page/qrcode/qrcodePhoneName.vue'], resolve),
          name: 'qrcodephonename',
          meta: { title: '手机昵称' }
        },
        {
          path: '/qrcodecontrol/qrcodecontrol',
          component: resolve => require(['../page/qrcode/qrcodecontrol.vue'], resolve),
          name: 'qrcodecontrol',
          meta: { title: '控制页' }
        },
        {
          path: '/qrcodecontrol/qrcodeDeviceAction',
          component: resolve => require(['../page/qrcode/qrcodeDeviceAction.vue'], resolve),
          name: 'qrcodedeviceaction',
          meta: { title: '单设备控' }
        },
        // {
        //   path: '/qrcodecontrol/areacontrol',
        //   component: resolve => require(['../page/qrcode/qrcodeAreaControl.vue'], resolve),
        //   name: 'qrcodeareacontrol',
        //   meta: { title: '区域控' }
        // },
        // {
        //   path: '/qrcodecontrol/scenelist',
        //   component: resolve => require(['../page/qrcode/qrcodeSceneList.vue'], resolve),
        //   name: 'qrcodescenelist',
        //   meta: { title: '场景控' }
        // },
      ]
    },
    {
      path: '/ai-paint',
      component: resolve => require(['../page/ai-paint/index.vue'], resolve),
      name: 'aiPaint',
      meta: { title: 'ai绘图' }
    }, 
    {
      path: '/ai-paint-mini',
      component: resolve => require(['../page/ai-paint/index-mini.vue'], resolve),
      name: 'aiPaint',
      meta: { title: 'ai绘图' }
    }, 
    {
      path: '/visualMap',
      component: resolve => require(['../page/visualMap/components/home.vue'], resolve),
      meta: { title: '画布' },
      children: [
        {
          path: '/visualMap/project',
          component: resolve => require(['../page/visualMap/components/LoactionAreaComponent/LoactionAreaList.vue'], resolve),
          name: 'project',
          meta: { title: '列表' }
        }, {
          path: '/visualMap/project/detailDetach/',
          component: resolve => require(['../page/visualMap/visual.vue'], resolve),
          name: 'detailDetach',
          meta: { title: '详情' }
        }]
    },
    {
      path: '/monitoringMap',
      component: resolve => require(['../page/monitor/monitorMap.vue'], resolve),
      name: 'monitoringMap',
      meta: { title: '监控地图' }
    }, 
  ]
})


const defaultTitle = 'OPPLE'
const pathArray = ['/projectDetails', '/setPsw', '/regist', '/login']
router.beforeEach( (to, from, next) => {
  if(to.path === '/monitoring' || to.path === '/install'){
    store.dispatch('changeRoutermsg', to.path)
  }
  store.dispatch('changeRoutermsg', to.path)
  XC_IP = window.fatherOrigin || XC_IP
  if (pathArray.includes(to.path)) {
    if (window.INVISIBLE) {
      next()
      return
    }
    const starOnline = store.state.starOnline // 星辰是否上线
    const isInXingCheng = store.state.isInXingCheng
    if (isInXingCheng) {
      if (window.parent && window.parent.postMessage) {
        window.parent.postMessage({ type: 'LINK_LOGIN' }, XC_IP)
      }
      return
    }
    if (starOnline) {
      let _herf = window.fatherOrigin ? window.fatherOrigin : process.env.VUE_APP_XC_IFRAME_URL
      if(_herf){
        let herf = `${_herf}/#/login`
        window.location.href = herf
        return
      }
      return
    }
  }
  //  内嵌星辰时,进入地图页面,需要修改样式
  if (to.path === '/monitoringMap' || to.path === '/visualMap' || to.path === '/visualMap/project' || to.path === '/visualMap/project/detailDetach') {
    const isInXingCheng = store.state.isInXingCheng
    if (window.parent && window.parent.postMessage && isInXingCheng) {
      window.parent.postMessage({ type: 'XC_IN_MAP', payload: { result: true } }, XC_IP)
    }
  } else {
    const isInXingCheng = store.state.isInXingCheng
    if (window.parent && window.parent.postMessage && isInXingCheng) {
      window.parent.postMessage({ type: 'XC_IN_MAP', payload: { result: false } }, XC_IP)
    }
  }

  const targetMenuIndex = routeHighlightMap[to.path] || to.path;
  store.dispatch('changeRoutermsg', targetMenuIndex);

  /* change title */
  document.title = defaultTitle
  /* 进行域名切换判断 */
  // if(to.name === 'login'){
  // }else{
  next()
  // }

})


export default router
